import type { ValidationOptions } from '@subscriptions/domain/types';

/**
 * Creates a value resolver bound to an entity factory's validation options.
 *
 * In strict mode (default) the value-object factory runs as-is and validation
 * errors propagate, keeping write flows protected. With `softValidation: true`
 * (read/reconstruction flows) a failing factory degrades to the provided
 * fallback so corrupt backend data renders as an empty field ("-") in the UI
 * instead of breaking the whole list/detail render.
 *
 * @param options - Validation options received by the entity factory
 * @returns Resolver that runs a value-object factory with the configured tolerance
 */
export const createValueResolver = (options?: ValidationOptions) => {
  return <T>(make: () => T, fallback: T): T => {
    if (!options?.softValidation) {
      return make();
    }
    try {
      return make();
    } catch {
      return fallback;
    }
  };
};
